var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "bg-white pt-5 px-3 sm:p-6" }, [
    _c("div", { staticClass: "flex flex-col" }, [
      _c("div", { staticClass: "flex flex-col sm:flex-row w-full sm:w-auto" }, [
        _c("div", { staticClass: "left-side-bar w-full sm:w-auto relative" }, [
          _c(
            "button",
            {
              class: [
                "w-full p-3 py-2 rounded-lg focus:outline-none text-sm bg-yellow-100 font-medium text-black flex justify-between items-center sm:hidden relative z-10",
              ],
              attrs: { id: "main-tab" },
              on: {
                click: function ($event) {
                  _vm.showMobileSidebar = !_vm.showMobileSidebar
                },
              },
            },
            [
              _vm._v(
                " " +
                  _vm._s(
                    _vm.sidebarTabs.find((tab) => tab.id === _vm.activeTab)
                      ?.name || "Select Tab"
                  ) +
                  " "
              ),
              _c("div", { staticClass: "rotate-180" }, [_c("ChevronIcon")], 1),
            ]
          ),
          _c(
            "div",
            {
              class: [
                "space-y-1 sm:space-y-2 bg-default-light-grey left-side-bar-content -mt-5 sm:mt-0 pt-6 sm:p-6 absolute left-0 top-full right-0 sm:static",
                _vm.showMobileSidebar ? "" : "hidden sm:block",
              ],
              attrs: { id: "info" },
            },
            _vm._l(_vm.sidebarTabs, function (tab, index) {
              return _c(
                "button",
                {
                  key: index,
                  class: [
                    "w-full text-left px-3 sm:px-4 py-2 rounded-lg focus:outline-none left-bar-button text-sm sm:text-lg font-normal",
                    _vm.activeTab === tab.id
                      ? "yellowBG sm:font-medium sm:text-black"
                      : "sm:hover:bg-gray-50 sm:text-gray-400",
                  ],
                  on: {
                    click: () => {
                      _vm.activeTab = tab.id
                      _vm.showMobileSidebar = false
                    },
                  },
                },
                [_vm._v(" " + _vm._s(tab.name) + " ")]
              )
            }),
            0
          ),
        ]),
        _c(
          "div",
          { staticClass: "w-full sm:w-auto" },
          [
            _vm.activeTab === "basic"
              ? _c("BasicInformation", {
                  attrs: { data: _vm.clientData },
                  on: { edit: _vm.handleEdit },
                })
              : _vm._e(),
            _vm.activeTab === "required"
              ? _c("RequiredServices", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "emergency"
              ? _c("EmergencyContact", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "access"
              ? _c("AccessInformation", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "language"
              ? _c("LanguageCommunication", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "health"
              ? _c("HealthInformation", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "assessment"
              ? _c("FunctionalAssessment", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "considerations"
              ? _c("PersonalConsiderations", {
                  attrs: { data: _vm.clientData },
                })
              : _vm._e(),
            _vm.activeTab === "network"
              ? _c("SupportNetwork", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "goals"
              ? _c("CareGoals", { attrs: { data: _vm.clientData } })
              : _vm._e(),
            _vm.activeTab === "notes"
              ? _c("AdditionalNotes", { attrs: { data: _vm.clientData } })
              : _vm._e(),
          ],
          1
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }